/**
 * Re-exports scenario enums from shared package (single source of truth).
 * Portal-specific interfaces remain here.
 */
export {
  ScenarioTypeEnum,
  ComplexityTierEnum,
  DeadEndTypeEnum,
} from "@shared/config/scenarios/types";

// Portal-specific enums (not part of scenario logic)
export enum SecurityTypeEnum {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  IRA_401_FUNDS_BONDS = "IRA_401_FUNDS_BONDS",
}

export enum FormatEnum {
  PHYSICAL = "PHYSICAL",
  ELECTRONIC = "ELECTRONIC",
}

export enum StockholderTypeEnum {
  CORPORATE = "CORPORATE", //Corporate / LLC
  PRIVATE = "PRIVATE", //Individual / Joint
  DECEASED = "DECEASED", //Executor / Trustee
  REDEMPTION = "REDEMPTION", // TBD.
}

export interface CreateTransactionInterface {
  securityType: SecurityTypeEnum;
  format: FormatEnum;
  stockholderType: StockholderTypeEnum;
  transferAgentUUID: string;
}
